import { defineMessages } from 'react-intl';

export const sharedMessages = defineMessages({
  actions: {
    id: 'Actions',
    defaultMessage: 'Actions',
  },
  all: {
    id: 'All',
    defaultMessage: 'All',
  },
  applicationNumber: {
    id: 'Application number',
    defaultMessage: 'Application number',
  },
  backToJob: {
    id: 'Back to job',
    defaultMessage: 'Back to job',
  },
  backToMatters: {
    id: 'Back to matters',
    defaultMessage: 'Back to matters',
  },
  backToOverview: {
    id: 'Back to overview',
    defaultMessage: 'Back to overview',
  },
  backToTools: {
    id: 'Back to tools',
    defaultMessage: 'Back to tools',
  },
  businessDayBuffer: {
    id: 'Business-day buffer',
    defaultMessage: 'Business-day buffer',
  },
  cancel: {
    id: 'Cancel',
    defaultMessage: 'Cancel',
  },
  cancelChanges: {
    id: 'Cancel changes',
    defaultMessage: 'Cancel changes',
  },
  client: {
    id: 'Client',
    defaultMessage: 'Client',
  },
  clientDeadline: {
    id: 'Client deadline',
    defaultMessage: 'Client deadline',
  },
  clientDueDate: {
    id: 'Client due date',
    defaultMessage: 'Client due date',
  },
  clientPending: {
    id: 'Client pending',
    defaultMessage: 'Client pending',
  },
  createMatter: {
    id: 'Create matter',
    defaultMessage: 'Create matter',
  },
  createJob: {
    id: 'Create job',
    defaultMessage: 'Create job',
  },
  creating: {
    id: 'Creating…',
    defaultMessage: 'Creating…',
  },
  delete: {
    id: 'Delete',
    defaultMessage: 'Delete',
  },
  deleting: {
    id: 'Deleting…',
    defaultMessage: 'Deleting…',
  },
  dueSourceClient: {
    id: 'From client due',
    defaultMessage: 'From client due',
  },
  dueSourceInternal: {
    id: 'Manual internal due',
    defaultMessage: 'Manual internal due',
  },
  dueSourceLegal: {
    id: 'From legal due',
    defaultMessage: 'From legal due',
  },
  editJobKinds: {
    id: 'Edit job kinds',
    defaultMessage: 'Edit job kinds',
  },
  estimatedHours: {
    id: 'Estimated hours',
    defaultMessage: 'Estimated hours',
  },
  hours: {
    id: 'Hours',
    defaultMessage: 'Hours',
  },
  incomingDate: {
    id: 'Incoming date',
    defaultMessage: 'Incoming date',
  },
  internalDue: {
    id: 'Internal due',
    defaultMessage: 'Internal due',
  },
  internalDueDate: {
    id: 'Internal due date',
    defaultMessage: 'Internal due date',
  },
  internalWorkingDeadline: {
    id: 'Internal working deadline',
    defaultMessage: 'Internal working deadline',
  },
  jobKind: {
    id: 'Job kind',
    defaultMessage: 'Job kind',
  },
  jobTitle: {
    id: 'Job title',
    defaultMessage: 'Job title',
  },
  jobs: {
    id: 'Jobs',
    defaultMessage: 'Jobs',
  },
  jurisdiction: {
    id: 'Jurisdiction',
    defaultMessage: 'Jurisdiction',
  },
  legalDeadline: {
    id: 'Legal deadline',
    defaultMessage: 'Legal deadline',
  },
  legalDueDate: {
    id: 'Legal due date',
    defaultMessage: 'Legal due date',
  },
  loading: {
    id: 'Loading…',
    defaultMessage: 'Loading…',
  },
  logIn: {
    id: 'Log in',
    defaultMessage: 'Log in',
  },
  logOut: {
    id: 'Log out',
    defaultMessage: 'Log out',
  },
  matter: {
    id: 'Matter',
    defaultMessage: 'Matter',
  },
  matterReferenceCode: {
    id: 'Matter reference code',
    defaultMessage: 'Matter reference code',
  },
  matterRef: {
    id: 'Matter ref',
    defaultMessage: 'Matter ref',
  },
  matters: {
    id: 'Matters',
    defaultMessage: 'Matters',
  },
  matterStatus: {
    id: 'Matter status',
    defaultMessage: 'Matter status',
  },
  matterTitle: {
    id: 'Matter title',
    defaultMessage: 'Matter title',
  },
  newJob: {
    id: 'New job',
    defaultMessage: 'New job',
  },
  noValue: {
    id: 'No value dash',
    defaultMessage: '—',
  },
  notes: {
    id: 'Notes',
    defaultMessage: 'Notes',
  },
  notAssigned: {
    id: 'Not assigned',
    defaultMessage: 'Not assigned',
  },
  openOaWorkspace: {
    id: 'Open OA workspace',
    defaultMessage: 'Open OA workspace',
  },
  overview: {
    id: 'Overview',
    defaultMessage: 'Overview',
  },
  patentManager: {
    id: 'Patent Manager',
    defaultMessage: 'Patent Manager',
  },
  priority: {
    id: 'Priority',
    defaultMessage: 'Priority',
  },
  remainingHours: {
    id: 'Remaining hours',
    defaultMessage: 'Remaining hours',
  },
  registerJob: {
    id: 'Register job',
    defaultMessage: 'Register job',
  },
  registerMatter: {
    id: 'Register matter',
    defaultMessage: 'Register matter',
  },
  responsibleAttorney: {
    id: 'Responsible attorney',
    defaultMessage: 'Responsible attorney',
  },
  save: {
    id: 'Save',
    defaultMessage: 'Save',
  },
  saving: {
    id: 'Saving…',
    defaultMessage: 'Saving…',
  },
  searchMatters: {
    id: 'Search matters',
    defaultMessage: 'Search matters',
  },
  shown: {
    id: 'Shown',
    defaultMessage: 'shown',
  },
  status: {
    id: 'Status',
    defaultMessage: 'Status',
  },
  titleActions: {
    id: 'Actionable jobs',
    defaultMessage: 'Actionable jobs',
  },
  titleMatterRegistry: {
    id: 'Matter registry',
    defaultMessage: 'Matter registry',
  },
  titleTools: {
    id: 'Tools',
    defaultMessage: 'Tools',
  },
  today: {
    id: 'Today',
    defaultMessage: 'Today',
  },
  tools: {
    id: 'Tools nav',
    defaultMessage: 'Tools',
  },
  unassignedClient: {
    id: 'Unassigned client',
    defaultMessage: 'Unassigned client',
  },
  untitledMatter: {
    id: 'Untitled matter',
    defaultMessage: 'Untitled matter',
  },
  updating: {
    id: 'Updating…',
    defaultMessage: 'Updating…',
  },
});

const tokenMessages = defineMessages({
  abandoned: {
    id: 'abandoned',
    defaultMessage: 'Abandoned',
  },
  active_prosecution: {
    id: 'active_prosecution',
    defaultMessage: 'Active prosecution',
  },
  allowed: {
    id: 'allowed',
    defaultMessage: 'Allowed',
  },
  awaiting_instruction: {
    id: 'awaiting_instruction',
    defaultMessage: 'Awaiting instruction',
  },
  blocked: {
    id: 'blocked',
    defaultMessage: 'Blocked',
  },
  cancelled: {
    id: 'cancelled',
    defaultMessage: 'Cancelled',
  },
  closed: {
    id: 'closed',
    defaultMessage: 'Closed',
  },
  critical: {
    id: 'critical',
    defaultMessage: 'Critical',
  },
  done: {
    id: 'done',
    defaultMessage: 'Done',
  },
  en: {
    id: 'English',
    defaultMessage: 'English',
  },
  granted: {
    id: 'granted',
    defaultMessage: 'Granted',
  },
  high: {
    id: 'high',
    defaultMessage: 'High',
  },
  in_progress: {
    id: 'in_progress',
    defaultMessage: 'In progress',
  },
  ja: {
    id: 'Japanese',
    defaultMessage: 'Japanese',
  },
  legal: {
    id: 'Legal',
    defaultMessage: 'Legal',
  },
  light: {
    id: 'light',
    defaultMessage: 'Light',
  },
  low: {
    id: 'low',
    defaultMessage: 'Low',
  },
  medium: {
    id: 'medium',
    defaultMessage: 'Medium',
  },
  neutral: {
    id: 'neutral',
    defaultMessage: 'Neutral',
  },
  not_assigned: {
    id: 'not_assigned',
    defaultMessage: 'Not assigned',
  },
  not_started: {
    id: 'not_started',
    defaultMessage: 'Not started',
  },
  open: {
    id: 'open',
    defaultMessage: 'Open',
  },
  queued_for_review: {
    id: 'queued_for_review',
    defaultMessage: 'Queued for review',
  },
  ready_to_file: {
    id: 'ready_to_file',
    defaultMessage: 'Ready to file',
  },
  triage: {
    id: 'triage',
    defaultMessage: 'Triage',
  },
  waiting_on_client: {
    id: 'waiting_on_client',
    defaultMessage: 'Waiting on client',
  },
  waiting_on_foreign_associate: {
    id: 'waiting_on_foreign_associate',
    defaultMessage: 'Waiting on foreign associate',
  },
});

function extractToken(value) {
  if (typeof value === 'string' && value.trim()) {
    return value.trim();
  }
  if (Array.isArray(value)) {
    return extractToken(value.find((item) => typeof item === 'string' && item.trim()));
  }
  if (value && typeof value === 'object') {
    return extractToken(value.token || value.title || value.value || '');
  }
  return '';
}

export function formatTokenMessage(intl, value, fallback = sharedMessages.noValue.defaultMessage) {
  const token = extractToken(value);
  if (!token) {
    return fallback;
  }
  const normalized = token.replace(/\s+/g, '_').toLowerCase();
  const message = tokenMessages[normalized];
  return message ? intl.formatMessage(message) : token.replace(/_/g, ' ');
}

export function formatDueSourceMessage(intl, value) {
  if (value === 'legal') {
    return intl.formatMessage(sharedMessages.dueSourceLegal);
  }
  if (value === 'client') {
    return intl.formatMessage(sharedMessages.dueSourceClient);
  }
  return intl.formatMessage(sharedMessages.dueSourceInternal);
}

export function formatMatterReferenceMessage(intl, value) {
  const normalized = String(value || '').trim();
  return normalized && normalized !== 'not assigned'
    ? normalized
    : intl.formatMessage(sharedMessages.notAssigned);
}

export function formatClientNameMessage(intl, value) {
  const normalized = String(value || '').trim();
  return normalized
    ? normalized
    : intl.formatMessage(sharedMessages.unassignedClient);
}

export function formatMatterTitleMessage(intl, value) {
  const normalized = String(value || '').trim();
  return normalized
    ? normalized
    : intl.formatMessage(sharedMessages.untitledMatter);
}
